<template>
    <section class="m-cooperation-part">
        <div v-for="item in cooperationDatas" :key="item.id">
            <div v-for="itemele in item" :key="itemele.id">
                <Title v-if="itemele.category=='title'" :titleArr="itemele.data"></Title>
                <Logo1 v-if="itemele.category=='logoArr'" :logo1Arr="itemele.data"></Logo1>
            </div>
        </div>
    </section>
</template>
<script>
import Title from "@/components/Title";
import Logo1 from "@/components/Logo";
export default {
    name: "opinion",
    components: {
        Title,
        Logo1
    },
    data() {
        return {
            cooperationDatas: pageDatas.cooperationDatas
        };
    }
};
</script>